import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            language: 'Languages/getSelectedCountryCode',
        })
    },
    methods: {
        async updateContent () {
            await this.$store.dispatch(this.storeUpdateContentAction)
        }
    },
    watch: {
        language: function () {
            this.updateContent()
        }
    },
    async created () {
        await this.updateContent()
    }
}
